import {Component, ChangeDetectorRef, Inject} from '@angular/core';
import { AppComponent } from '../app.component';
import { NmdpWidget } from '@nmdp/nmdp-login';

@Component({
  selector: 'footer-component',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent  {
    currentYear = 0;

    constructor(private ref:ChangeDetectorRef, public readonly appComponent: AppComponent, @Inject(NmdpWidget) readonly loginWidget: NmdpWidget) {
        this.currentYear = (new Date()).getFullYear();
      appComponent.guest=this.loginWidget.isGuestUser();
    }
}
